export default __webpack_public_path__ + "static/seedling-hover-465e9e7046108c407307b3748ad9a892.png";